import React from "react";
import { PRIORITIES } from "../constants/config";
import { SURFACE, TEXT } from "../constants/colors";

const PriorityBadge = ({ priority }) => {
  const p = PRIORITIES[priority];
  if (!p) return null;

  return (
    <span
      style={{
        fontSize: 10,
        fontWeight: 700,
        padding: "1px 5px",
        borderRadius: 3,
        background: SURFACE.barBg,
        color: p.color,
        border: `1px solid ${p.color}40`,
        fontFamily: "Poppins",
        letterSpacing: 1,
      }}
    >
      {p.label}
    </span>
  );
};

export default PriorityBadge;
